import React from 'react';
import { Button, Icon, Tooltip } from '@saviynt/design-system';
import cx from 'classnames';

import { useInvertedLocalize } from '../../../utilities';

import { invertedMessages } from './messages';
import PersonalizationModal from './PersonalizationModal';
import testIds from './testIds';

import './PersonalizationButton.css';

interface PersonalizationTileProps {
  isInTile: boolean;
  isSmallTabletFormFactor: boolean;
}

/**
 * Displays the personalization subfeature.
 */
export default function PersonalizationTile({
  isInTile,
  isSmallTabletFormFactor,
}: PersonalizationTileProps): JSX.Element {
  const [isConfiguring, setIsConfiguring] = React.useState<boolean>(false);
  const handleClick = () => setIsConfiguring(true);
  const handleModalClose = () => setIsConfiguring(false);
  const className = cx(
    'Nav_PersonalizationButton',
    isInTile && `Nav_PersonalizationButton--isInTile`
  );
  const size = isInTile ? 'small' : 'large';
  const l = useInvertedLocalize(invertedMessages);

  return (
    <>
      <Tooltip
        trigger={
          <Button
            ariaLabel={l('Customize shortcut tiles')}
            dataTestId={testIds.SHORTCUTS_PERSONALIZATION_BUTTON}
            className={className}
            onClick={handleClick}
            size={size}
            kind='filled'
            leftIcon={<Icon kind='Settings' />}
          />
        }
        text={l('Tile Options')}
        placement='left'
      />
      <PersonalizationModal
        isOpen={isConfiguring}
        onClose={handleModalClose}
        isSmallTabletFormFactor={isSmallTabletFormFactor}
      />
    </>
  );
}
